//BUYERS Listing
export const FETCH_PAYEES_LISTING_FAILURE = 'FETCH_PAYEES_LISTING_FAILURE';
export const FETCH_PAYEES_LISTING_SUCCESS = 'FETCH_PAYEES_LISTING_SUCCESS';

export const RESET = 'RESET';
